var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 223.00215 107.7",
    width: 223.00215,
    height: 107.7,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs944"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style885"
  }, "\n\n\t.st1{fill:#EC1C24;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g911",
    style: {
      fill: "#ffffff"
    },
    transform: "translate(-26.397849,-14.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g897",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 58.3,122.1 v -20.6 h 13.6 v 3.6 h -9.5 v 4.8 h 8.1 v 3.6 h -8.1 v 5 h 9.5 v 3.6 z",
    id: "path889",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.2,122.1 80,109.4 V 122 h -4 v -20.6 h 3.6 l 8.1,12.6 v -12.6 h 4 V 122 Z",
    id: "path891",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.8,122.2 c -2.2,0 -3.8,-0.6 -5.3,-2.1 l 2.7,-2.6 c 0.7,0.7 1.3,1.2 2.6,1.2 2,0 3.2,-1.2 3.2,-3.5 v -13.6 h 4 v 13.8 c 0,4.4 -3.4,6.8 -7.2,6.8 z",
    id: "path893",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.2,120 c -1.4,1.4 -3.2,2.3 -5.5,2.3 -2.3,0 -4.1,-0.8 -5.6,-2.3 -2.1,-2.1 -2,-4.7 -2,-8.2 0,-3.5 -0.1,-6.1 2,-8.2 1.4,-1.4 3.2,-2.3 5.6,-2.3 2.3,0 4.1,0.8 5.5,2.3 2.1,2.1 2.1,4.7 2.1,8.2 0,3.5 0,6.1 -2.1,8.2 z m -2.9,-14 c -0.6,-0.7 -1.5,-1.1 -2.6,-1.1 -1.1,0 -2,0.4 -2.6,1.1 -0.8,0.9 -1,1.8 -1,5.8 0,4 0.2,4.9 1,5.8 0.6,0.7 1.5,1.1 2.6,1.1 1.1,0 2,-0.4 2.6,-1.1 0.8,-0.9 1,-1.8 1,-5.8 0,-4 -0.3,-4.9 -1,-5.8 z",
    id: "path895",
    style: {
      fill: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g909",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 138.1,113.6 v 8.4 h -4 v -8.4 l -6.2,-12.1 h 4.4 l 3.8,8.3 3.8,-8.3 h 4.4 z",
    id: "path899",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158,105.1 v 5.1 h 8.1 v 3.6 H 158 v 8.4 h -4 v -20.6 h 13.6 v 3.6 z",
    id: "path901",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 182.2,122.1 -4,-8.2 h -2.9 v 8.2 h -4 v -20.6 h 8.1 c 4.2,0 6.7,2.9 6.7,6.3 0,2.9 -1.8,4.7 -3.8,5.4 l 4.6,8.9 c 0,0 -4.7,0 -4.7,0 z m -3.2,-17 h -3.8 v 5.4 h 3.8 c 1.8,0 2.9,-1.1 2.9,-2.7 0.1,-1.6 -1.1,-2.7 -2.9,-2.7 z",
    id: "path903",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 190.4,122.1 V 101.5 H 204 v 3.6 h -9.5 v 4.8 h 8.1 v 3.6 h -8.1 v 5 h 9.5 v 3.6 z",
    id: "path905",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 208.1,122.1 v -20.6 h 13.6 v 3.6 h -9.5 v 4.8 h 8.1 v 3.6 h -8.1 v 5 h 9.5 v 3.6 z",
    id: "path907",
    style: {
      fill: "#ffffff"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g939",
    transform: "translate(-26.397849,-14.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g915"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 245.8,77.6 c -2,0 -3.6,-1.6 -3.6,-3.6 0,-2 1.6,-3.6 3.6,-3.6 2,0 3.6,1.6 3.6,3.6 0,2 -1.6,3.6 -3.6,3.6 z m 0,-6.6 c -1.7,0 -3.1,1.4 -3.1,3.1 0,1.7 1.4,3.1 3.1,3.1 1.7,0 3.1,-1.4 3.1,-3.1 0,-1.7 -1.4,-3.1 -3.1,-3.1 z",
    id: "path913"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 247.3,76.1 -0.8,-1.9 c 0.5,-0.1 0.7,-0.5 0.7,-1 0,-0.3 -0.2,-0.7 -0.4,-0.9 -0.3,-0.2 -0.6,-0.2 -0.9,-0.2 h -1.5 v 4 h 0.5 v -1.7 h 1.1 l 0.7,1.7 z m -2.4,-2.2 v -1.4 h 1 c 0.2,0 0.4,0 0.6,0.1 0.2,0.1 0.3,0.3 0.3,0.5 0,0.2 -0.1,0.4 -0.2,0.5 -0.2,0.2 -0.4,0.2 -0.7,0.2 h -1 z",
    id: "path917"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g927"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 80.4,53.3 c 0,-15.3 5.7,-25 12.4,-26 -6.7,-8.3 -18,-12.7 -28.3,-12.7 -11.3,0 -21.4,4.9 -28.4,12.7 6.7,1.3 8.9,6.9 8.9,15.6 h -8.2 c 0,-5.1 -1.1,-7.8 -4.1,-7.8 -1.4,0 -2.4,0.7 -3,1.9 -0.1,0.2 -0.2,0.4 -0.3,0.6 -0.2,0.7 -0.4,1.4 -0.4,2.3 0,10.6 17.4,10.1 17.4,26.3 0,6.4 -4.9,12.3 -10.4,12.3 7.2,7.9 17,12.6 28.4,12.6 11,0 20.9,-4.7 27.9,-12.1 C 86,77.2 80.4,68 80.4,53.3 Z M 76.8,78.5 H 68 V 56.8 H 58.6 V 78.5 H 49.8 V 28.3 h 8.7 V 48.5 H 68 V 28.3 h 8.7 v 50.2 z",
    id: "path921"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 33.9,70.5 c 2.4,0 4.2,-2.2 4.2,-5.3 0,-6.5 -5.7,-7.7 -11.7,-13.2 -0.1,11.1 3.3,18.5 7.5,18.5 z",
    id: "path923"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 89.1,52.5 c 0,-8.4 2.5,-16.9 6.9,-16.9 5.3,0 6.7,13.1 6.7,17.2 0,9.1 -2.9,17.2 -6.7,17.2 -4.5,0 -6.9,-8.6 -6.9,-17.5 z",
    id: "path925"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g935"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "146,29 144.9,29 139.6,29 136.1,57.7 136,57.7 132,29 124,29 119.8,57.7 119.6,57.7 116.5,29 108.4,29 114.9,77.8 122.7,77.8 127.1,46.9 127.2,46.9 131.5,77.8 139.6,77.8 145,36.6 152.5,36.6 152.5,77.8 161.5,77.8 161.5,36.6 169.6,36.6 169.6,77.8 178.5,77.8 178.5,29 176.4,29 169.6,29 ",
    id: "polygon929"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 182.9,29 h 11.9 l 4,25 h 0.1 l 4.2,-25 h 11.6 v 48.8 h -8 V 42.1 h -0.1 l -6,35.8 h -4.9 l -6,-35.8 h -0.1 V 77.9 H 183 Z",
    id: "path931"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 219,29 h 20.2 v 7.5 H 228 V 49 h 8.3 v 8 H 228 v 13.3 h 11.7 v 7.5 H 219 Z",
    id: "path933"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowtime);
export default __webpack_public_path__ + "static/media/Showtime.60e33daae2bbcc21a2c3ef9201670fa6.svg";
export { ForwardRef as ReactComponent };